import ky from 'ky';

export async function sendImpulse (payload) {
  if (!window.sbvrenv.IMPULSE_ENDPOINT) return;
  return ky.post(`https://timescaledb.deployreality.com/impulse?v=${COMMITHASH}`, {
    json: payload,
  });
}
// {
//     "client_recorded_at": "date-time", // required
//     "state": "idle" | "play" | "overlay", // required
//     "duration": "number", // required
//     "organization": { // required
//         "uuid": "string", // required
//         "title": "string", // required
//         "country": "string", // required
//         "region": "string" // required
//     },
//     "location": { // required
//         "uuid": "string", // required
//         "title": "string", // required
//         "country": "string",
//         "region": "string"
//     },
//     "station": { // required
//         "uuid": "string", // required
//         "title": "string" // required
//     },
//     "content": {
//         "uuid": "string", // required
//         "type": "game" | "launcher", // required
//         "title": "string", // required
//         "preset": {
//             "uuid": "string", // required
//             "title": "string" // required
//         },
//     },
//     "license": {
//         "uuid": "string" // required
//     },
//     "content_ownership": {
//         "uuid": "string" // required
//     },
//     "booking": {
//         "uuid": "string" // required
//     },
//     "customer": {
//         "uuid": "string" // required
//     },
//     "transaction_id": {
//         "type": "string"
//     }
// }
